import { Flex } from '@rebass/grid';
import React, { FC } from 'react';
import styled from 'styled-components';
import LabelButton from '../action/LabelButton';
import CircleView from '../figure/CircleView';
import Play from '../figure/Play';

interface Props {
    videoUrl?: string | null;
    fullCircleImageUrl?: string | null;
}

const VideoLabel: FC<React.PropsWithChildren<Props>> = ({ videoUrl, fullCircleImageUrl }) =>
    videoUrl ? (
        <LabelContainer>
            <LabelButton icon={<Play />} disabled>
                Video
            </LabelButton>
            {fullCircleImageUrl && (
                <LabelButton icon={<CircleView />} disabled style={{ marginLeft: '4px' }}>
                    360 &#176;
                </LabelButton>
            )}
        </LabelContainer>
    ) : null;

const LabelContainer = styled(Flex)`
    position: absolute;
    right: ${({ theme }) => theme.spacing['30_Small']};
    bottom: ${({ theme }) => theme.spacing['30_Small']};
    z-index: 1;
`;
export default VideoLabel;
